import { ReportComponent } from '@/types';
import { DatasetQuery, ReportComponentConfig } from '@/types/api/modules/business-intelligence';

export function compileComponentToQuery(_component: ReportComponent, draft: ReportComponentConfig): DatasetQuery {
    return {
        datasetId: draft?.dataSet?.key ?? draft.query?.datasetId ?? '',
        metrics: draft.query?.metrics ?? [],
        dimensions: draft.query?.dimensions ?? [],
        filters: draft.query?.filters ?? undefined,
        dateRange: draft.query?.dateRange ?? undefined,
        limit: draft.query?.limit ?? 100,
    };
}
